export default __webpack_public_path__ + "static/media/k-logo.5cad266a.svg";